module.exports = "https://static.wmbcdn.com/uniweb/images/2fabad97ef3bb7f38afa7c202df8f34f.svg";